<script setup lang="ts">
import { ref } from 'vue'
import type { Question } from './calendarQuestion'
import CalendarQuestionItem from './CalendarQuestionItem/CalendarQuestionItem.vue'
import CalendarQuestionsNavigation from './CalendarQuestionsNavigation/CalendarQuestionsNavigation.vue'

const model = defineModel<Question[]>()
defineProps<{
  formErrors: (string | undefined)[]
}>()

const selectingIndex = ref<number | null>(null)

const moveUp = (index: number) => {
  if (!model.value) return
  if (index <= 0 || index >= model.value.length) return

  const tempModel = [...model.value]
  const temp = tempModel[index - 1]
  tempModel[index - 1] = tempModel[index]
  tempModel[index] = temp
  model.value = tempModel

  if (selectingIndex.value === index) {
    selectingIndex.value = index - 1
  } else if (selectingIndex.value === index - 1) {
    selectingIndex.value = index
  }
}

const moveDown = (index: number) => {
  if (!model.value) return
  if (index < 0 || index >= model.value.length - 1) return

  const tempModel = [...model.value]
  const temp = tempModel[index + 1]
  tempModel[index + 1] = tempModel[index]
  tempModel[index] = temp
  model.value = tempModel

  if (selectingIndex.value === index) {
    selectingIndex.value = index + 1
  } else if (selectingIndex.value === index + 1) {
    selectingIndex.value = index
  }
}

const remove = (index: number) => {
  if (!model.value) return
  if (index < 0 || index >= model.value.length) return

  model.value = model.value.filter((_, i) => i !== index)

  if (selectingIndex.value === index) {
    selectingIndex.value = null
  } else if (selectingIndex.value !== null && selectingIndex.value > index) {
    selectingIndex.value -= 1
  }
}
</script>
<template>
  <div :class="$style.form">
    <CalendarQuestionsNavigation
      v-model="model"
      :selecting-index="selectingIndex"
      :class="$style.navigation"
    />
    <div :class="$style.questions">
      <CalendarQuestionItem
        v-for="(question, index) in model"
        :key="index"
        :question="question"
        :is-selected="selectingIndex === index"
        :formError="formErrors.at(index)"
        @select="selectingIndex = index"
        @up="moveUp(index)"
        @down="moveDown(index)"
        @remove="remove(index)"
      />
    </div>
  </div>
</template>
<style lang="scss" module>
.form {
  display: flex;
  gap: 16px;
}

.navigation {
  flex-shrink: 0;
  width: 200px;
}

.questions {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
}
</style>
